var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "#323130",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6.03961e-10C8.74546 6.03961e-10 8.94961 0.176875 8.99194 0.410124L9 0.5V9.5C9 9.77614 8.77614 10 8.5 10C8.25454 10 8.05039 9.82312 8.00806 9.58988L8 9.5V0.5C8 0.223858 8.22386 6.03961e-10 8.5 6.03961e-10ZM0.646447 0.146447C0.820013 -0.0271197 1.08944 -0.046405 1.28431 0.0885911L1.35355 0.146447L5.85355 4.64645C6.02712 4.82001 6.0464 5.08944 5.91141 5.28431L5.85355 5.35355L1.35355 9.85355C1.15829 10.0488 0.841709 10.0488 0.646447 9.85355C0.47288 9.67999 0.453595 9.41056 0.588591 9.21569L0.646447 9.14645L4.79289 5L0.646447 0.853553C0.451185 0.658291 0.451185 0.341709 0.646447 0.146447Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.269489d870fbb1dfb587579295be3567.svg";
export { ForwardRef as ReactComponent };